import axios from "axios";

// Override en prod (OVH) : si l'URL pointe vers un preview Emergent mais qu'on tourne sur un autre domaine,
// on bascule automatiquement sur l'origine du site (évite les erreurs CORS).
const envUrl = process.env.REACT_APP_BACKEND_URL || "";
const isBrowser = typeof window !== "undefined";
const isPreviewMismatch = isBrowser && envUrl && /emergentagent\.com/.test(envUrl) && !/emergentagent\.com/.test(window.location.hostname);

// Si on est sur arnakclan.com (déploiement satellite), le backend reste sur voamada.com.
const isArnakStandalone = isBrowser && /arnakclan\.com$/i.test(window.location.hostname);
const VOAMADA_ORIGIN = "https://www.voamada.com";

export const BACKEND_URL = isArnakStandalone ? VOAMADA_ORIGIN : (isPreviewMismatch ? "" : envUrl);
export const API = `${BACKEND_URL}/api`;
// Helper pour préfixer les chemins /uploads/... avec l'origine correcte (assets servis par voamada.com)
export const assetUrl = (p) => {
  if (!p) return p;
  if (/^https?:\/\//i.test(p)) return p;
  if (p.startsWith("/uploads/") && isArnakStandalone) return `${VOAMADA_ORIGIN}${p}`;
  return p;
};

export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Attach JWT token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("madafrica_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fileStreamUrl = (path) =>
  `${API}/files/stream?path=${encodeURIComponent(path)}`;

// JWT helpers
export const TOKEN_KEY = "madafrica_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => { if (t) localStorage.setItem(TOKEN_KEY, t); };
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
